import React from 'react';

export default function DiamondSwordSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Blade */}
      <path d="M20 2L24 22L20 24L16 22Z" fill="#5CE8E8" />
      {/* Blade edge highlight */}
      <path d="M20 2L22 18L20 20Z" fill="#88F0F0" />
      {/* Blade edge shadow */}
      <path d="M20 2L18 18L20 20Z" fill="#44C8D0" />
      {/* Blade center line */}
      <line x1="20" y1="4" x2="20" y2="20" stroke="#A0F8F8" strokeWidth="0.8" opacity="0.6" />
      {/* Sparkle on blade */}
      <path d="M18 8L19 7L20 8L19 9Z" fill="white" opacity="0.7" />
      <path d="M21 12L22 11L23 12L22 13Z" fill="white" opacity="0.5" />
      <circle cx="17" cy="14" r="0.5" fill="white" opacity="0.4" />
      {/* Guard / crossguard */}
      <rect x="13" y="22" width="14" height="3" rx="1" fill="#8B5E3C" />
      <rect x="14" y="22.5" width="12" height="2" rx="0.5" fill="#A87050" />
      {/* Handle */}
      <rect x="18" y="25" width="4" height="10" rx="1" fill="#6B4423" />
      {/* Handle wrap */}
      <line x1="18" y1="27" x2="22" y2="28" stroke="#8B5E3C" strokeWidth="0.8" />
      <line x1="18" y1="30" x2="22" y2="31" stroke="#8B5E3C" strokeWidth="0.8" />
      <line x1="18" y1="33" x2="22" y2="34" stroke="#8B5E3C" strokeWidth="0.8" />
      {/* Pommel */}
      <circle cx="20" cy="36" r="2" fill="#8B5E3C" />
      <circle cx="20" cy="36" r="1" fill="#5CE8E8" />
    </svg>
  );
}
